import { render, staticRenderFns } from "./hizliSatis.vue?vue&type=template&id=0747a636&scoped=true"
import script from "./hizliSatis.vue?vue&type=script&lang=js"
export * from "./hizliSatis.vue?vue&type=script&lang=js"
import style0 from "./hizliSatis.vue?vue&type=style&index=0&id=0747a636&prod&lang=scss&scoped=true"
import style1 from "./hizliSatis.vue?vue&type=style&index=1&id=0747a636&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747a636",
  null
  
)

export default component.exports